import {useEffect, useRef} from 'react';
import {setWorkerInterval} from '../utils/workerTimerUtils';

export const useWorkerInterval = (callback: () => void, delay: number | null, when?: boolean) => {
  const savedCallback = useRef<(() => void) | undefined>(undefined);

  savedCallback.current = callback;

  useEffect(() => {
    if (when) {
      return setWorkerInterval(() => {
        savedCallback.current?.();
      }, delay);
    }
  }, [delay, when]);
};
